import {
    SET_FLEET_AFE_CHANGE_LOG,
    SET_FLEET_ASSET_CHANGE_LOG
} from "./FleetAssetChangeLogType"

const initialState = {
    fleetAssetChangeLog: [],
    fleetAfeChangeLog: []
}


const reducer = (state = initialState, action: any) => {
    if (action.type === SET_FLEET_ASSET_CHANGE_LOG) {
        return {
            ...state,
            fleetAssetChangeLog: action.fleetAssetChangeLog
        }
    }else if (action.type === SET_FLEET_AFE_CHANGE_LOG) {
        return {
            ...state,
            fleetAfeChangeLog: action.fleetAfeChangeLog
        }
    }
    else {
        return state;
    }
};

export default reducer;